export const JWM_MONETIZATION_EXPERIMENT_DISMISSED_TRAIT =
	'jira_workmanagement_ui_jwmmonetisationbannerdismiss_clicked_last';

export const PACKAGE_NAME = 'jiraBusinessProgramMoonTrialBanner';

export const SESSION_STORAGE_KEY = 'showJWMPremiumUpgradeSuccessFlag';
